import { useEffect, useState } from "react";
import axios from "axios";
import lbnlogo from '../Images/lbnlogo.png';
import "./MemberFlyerHome.css";
import { useNavigate } from "react-router-dom";


export default function MemberFlyerHome() {

  const [members,setMembers] = useState([])
  const [visitedMembers,setVisitedMembers] = useState([])

  
const navigate = useNavigate();

  useEffect(()=>{
    fetchMembers()
  },[])

  useEffect(()=>{
  fetchMembers()
  fetchVisitedMembers()
},[])

  const fetchMembers = async()=>{

    try{

      const res = await axios.get("https://api.lbnhyderabad.com/signup/api/memberflyer/members")

      if(res.data.success){
        setMembers(res.data.members)
      }

    }catch(err){
      console.log(err)
    }

  }

const openMember = async(member)=>{

  const user = JSON.parse(localStorage.getItem("memberflyer"))

  try{

    await axios.post(
      "https://api.lbnhyderabad.com/signup/api/memberflyer/visit",
      {
        visitor_name: user.name,
        visitor_mobile: user.mobile,
        member_company: member.name_of_company,
        member_email: member.email,
        member_mobile: member.mobile
      }
    )

    if(!visitedMembers.includes(member.email)){
      setVisitedMembers(prev => [...prev, member.email])
    }

  }catch(err){
    console.log(err)
  }

  navigate(`/member-products/${member.email}`)
}

const fetchVisitedMembers = async()=>{

  const user = JSON.parse(localStorage.getItem("memberflyer"))

  try{

    const res = await axios.get(
      `https://api.lbnhyderabad.com/signup/api/memberflyer/visited/${user.mobile}`
    )

    if(res.data.success){

      const emails = res.data.visited.map(v => v.member_email)

      setVisitedMembers(emails)

    }

  }catch(err){
    console.log(err)
  }

}

console.log("visitedMembers",visitedMembers)

  return (

    <div className="memberflyer-container">

      {/* Header */}

      <header className="memberflyer-header">

        <div className="header-left">

          <img
            src={lbnlogo}
            alt="logo"
            className="header-logo"
          />

        </div>
<div className="top-strip">
  Visit Virtual Stalls of Member and <span className="win">WIN Prizes</span>
</div>
        <div className="header-title" style={{color:'#fff'}}>
          Member Flyer
        </div>

      </header>


      {/* Members Grid */}

      <div className="members-grid">

        {members.map((member)=>(
          
<div className="member-card" key={member.id} onClick={()=>openMember(member)}>

  {visitedMembers.includes(member.email) && (
    <div className="visited-stamp">Visited</div>
  )}

  <div className="logo-container">
    <img
      src={member.logo}
      alt={member.name}
      className="member-logo"
    />
  </div>
    <h6 className="company-name" style={{fontSize:14}}>
    {member.name}
  </h6>

  <h3 className="company-name">
    {member.name_of_company}
  </h3>

  <p className="business-vertical">
    {member.businessVerticalData}
  </p>

  <p className="business-vertical">
    {member.mobile}
  </p>

</div>

        ))}

      </div>

    </div>

  )

}